export default __webpack_public_path__ + "static/media/my-matches-Grey.e0c9bffa.svg";